import { NgModule } from "@angular/core";
import { BrowserModule } from "@angular/platform-browser";
import { AppComponent } from "./app.component";
import { HelpComponent } from "./help/help.component";
import { AppRoutingModule } from "./app-routing.module";
import { ContactusComponent } from "./contactus/contactus.component";
import { PrivacyPolicyComponent } from "./privacy-policy/privacy-policy.component";
import { CookiePolicyComponent } from "./cookie-policy/cookie-policy.component";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { HttpClientModule } from "@angular/common/http";
import { Ng2TelInputModule } from "ng2-tel-input";
import { ToastrModule } from "ngx-toastr";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { FreeDeliveryBranchComponent } from "./free-delivery-branch/free-delivery-branch.component";
import { FreeDeliveryJakartaComponent } from "./free-delivery-jakarta/free-delivery-jakarta.component";
import { FontAwesomeModule } from "@fortawesome/angular-fontawesome";
import { HomeComponent } from "./home/home.component";
import { RegisterComponent } from "./register/register.component";
import { RegisterCustomerComponent } from "./register/register-customer/registerCustomer.component";
import { TncComponent } from "./tnc/tnc.component";
import { KebijakanComponent } from "./kebijakan/kebijakan.component";
import { RegisterSalesComponent } from './register/register-sales/register-sales.component';
import { TermConditionComponent } from "./termCondition/term-condition";
import { HubungiKamiComponent  } from "./hubungi-kami/hubungiKami.component";
import { RegisterTrainingComponent } from "./register/register-training/registerTraining.component";
import { RegisterTraining2Component } from "./register/register-training2/registerTraining2.component";
import { AbsensiComponent } from "./register/absensi/absensi";
import { NgSelectModule } from '@ng-select/ng-select';
import {NgbModule} from '@ng-bootstrap/ng-bootstrap';
import { SlickCarouselModule } from 'ngx-slick-carousel';
import { AgmCoreModule } from '@agm/core';
import { HeaderComponent } from './component/header/header.component';
import { FooterComponent } from './component/footer/footer.component';


@NgModule({
  declarations: [
    AppComponent,
    HelpComponent,
    ContactusComponent,
    PrivacyPolicyComponent,
    CookiePolicyComponent,
    FreeDeliveryBranchComponent,
    FreeDeliveryJakartaComponent,
    HomeComponent,
    RegisterComponent,
    RegisterCustomerComponent,
    RegisterTrainingComponent,
    RegisterTraining2Component,
    AbsensiComponent,
    TncComponent,
    KebijakanComponent,
    RegisterSalesComponent,
    TermConditionComponent,
    HubungiKamiComponent,
    HeaderComponent,
    FooterComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    FormsModule,
    ReactiveFormsModule,
    NgSelectModule,
    HttpClientModule,
    Ng2TelInputModule,
    ToastrModule.forRoot(),
    NgbModule,
    SlickCarouselModule,
    AgmCoreModule.forRoot({apiKey: 'AIzaSyBu2jzm30Gyu9JKERpum6dEJgLOPU98S7M'}),
    BrowserAnimationsModule,
    FontAwesomeModule
  ],
  providers: [],
  bootstrap: [AppComponent],
})
export class AppModule {}
